import { render } from "./AggregatedReports.vue?vue&type=template&id=704bb753&scoped=true"
import script from "./AggregatedReports.vue?vue&type=script&lang=js"
export * from "./AggregatedReports.vue?vue&type=script&lang=js"

import "./AggregatedReports.vue?vue&type=style&index=0&id=704bb753&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704bb753"]])

export default __exports__